import { css } from '@src/common/styles/Styles';

type Props = {
  size: 'small' | 'medium' | 'large';
  text: string;
  color: string;
  borderColor: string;
  backgroundColor: string;
  radiusFull?: boolean;
};

export const StatusBadge = ({
  size,
  text,
  color,
  borderColor,
  backgroundColor,
  radiusFull,
}: Props) => {
  return (
    <span
      className={badgeStyleFromSize(
        size,
        color,
        borderColor,
        backgroundColor,
        radiusFull,
      )}
    >
      {text}
    </span>
  );
};

const badgeStyleFromSize = (
  size: 'small' | 'medium' | 'large',
  color: string,
  borderColor: string,
  backgroundColor: string,
  radiusFull?: boolean,
) =>
  css({
    display: 'inline-flex',
    alignItems: 'center',
    textAlign: 'center',
    border: `1px solid ${borderColor}`,
    backgroundColor,
    color,
    fontFamily: 'Poppins',
    width: 'fit-content',
    height: 'fit-content',
    ...badgeSizes[size],
    ...(radiusFull && { borderRadius: '9999px' }),
  });

const badgeSizes = {
  small: {
    borderRadius: '6px',
    padding: '2px 6px 2px 6px',
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '16px',
  },
  medium: {
    borderRadius: '6px',
    padding: '2px 8px 2px 8px',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '20px',
  },
  large: {
    borderRadius: '6px',
    padding: '4px 10px 4px 10px',
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '24px',
  },
};
